const typesOfSale = [
  {
    id: 9,
    name: 'Ventas Abandonadas'
  },
  {
    id: 1,
    name: 'Ventas Gratis'
  },
  {
    id: 0,
    name: 'Ventas Pagas'
  }
]

export default typesOfSale
